baseApp.service('SystemAllocatedIpsService', ['GeneralUtilsService', function(GeneralUtilsService, $rootScope) {

    let systemAllocatedIpsService = {};

    systemAllocatedIpsService.saveSystemAllocatedIpsChanges = function(changesToSave, callback) {
        store.fetch({
            path: '/saveSystemAllocatedIpsChanges',
            method: 'POST',
            dataObj: 'changesToSave',
            data: changesToSave,
            success: function (data) {
                callback(data);
            }
        })
    }

    return systemAllocatedIpsService;
}]);